
        export const NIKETEAM_NMP_BASEURL = 'https://assets.niketeam.nike.com';
export const NIKETEAM_NMP_SIGNER = 'abracadabra2'
